import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ANALYTICS_ENABLED, IS_BOT, sendPageView } from './platformAnalytics.js';

// Waits for the page to set its <title> and for redirect-only routes ("/" → "/home",
// guards → "/login") to move on before reporting.
const SETTLE_MS = 300;

// Module scope so a StrictMode double-mount cannot report the same page twice.
let lastSentPathname = null;

/** Reports one page view per route change to Quazbit's first-party platform analytics. */
export default function PageViewBeacon() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (!ANALYTICS_ENABLED || IS_BOT || lastSentPathname === pathname) return undefined;

        let onVisible = null;
        const send = () => {
            if (window.location.pathname !== pathname || lastSentPathname === pathname) return;
            lastSentPathname = pathname;
            sendPageView(pathname);
        };

        const timer = setTimeout(() => {
            if (document.visibilityState === 'visible') {
                send();
                return;
            }
            // Opened in a background tab: count it once the visitor actually looks at it.
            onVisible = () => {
                if (document.visibilityState !== 'visible') return;
                document.removeEventListener('visibilitychange', onVisible);
                onVisible = null;
                send();
            };
            document.addEventListener('visibilitychange', onVisible);
        }, SETTLE_MS);

        return () => {
            clearTimeout(timer);
            if (onVisible) document.removeEventListener('visibilitychange', onVisible);
        };
    }, [pathname]);

    return null;
}
